import { useFavSymbolsStore } from '@/stores/favSymbolsStore'
import type { MarketType } from '@/utils/types'
import { computed, onMounted, type Ref } from 'vue'

export const useFavoriteSymbols = (
  exBuy: Ref<string>,
  exSell: Ref<string>,
  marketType: Ref<MarketType>,
  asset: Ref<string>,
) => {
  const favSymbolStore = useFavSymbolsStore()

  onMounted(() => {
    favSymbolStore.fetchSymbols()
  })

  const favoriteId = computed(() => {
    const ok = favSymbolStore.symbols.filter(
      (x) =>
        x.asset.toLowerCase() == asset.value.toLowerCase() &&
        x.ex_buy.name == exBuy.value.toLowerCase() &&
        x.ex_sell.name == exSell.value.toLowerCase() &&
        x.market_type == marketType.value,
    )
    if (ok.length > 0) {
      return ok[0]?.id
    }
    return null
  })

  const toggleFavoriteSymbol = async () => {
    if (favSymbolStore.loading.fetch) {
      return
    }
    favSymbolStore.loading.fetch = true
    if (!favoriteId.value) {
      await favSymbolStore.pushSymbol(exBuy.value, exSell.value, marketType.value, asset.value)
      await favSymbolStore.fetchSymbols()
    } else {
      await favSymbolStore.deleteSymbol(favoriteId.value)
      await favSymbolStore.fetchSymbols()
    }
  }

  return {
    toggleFavoriteSymbol,
    favoriteId,
  }
}
